import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../../../../apis/data";
import { queryKey } from "../../../../../enumerations/queryKey";
import { cleanedParams } from "../../../../../plugins/utils";
import { ChatParams, ChatResponse, SendChatParams } from "./data";
import { apiGetChatContent, apiSendChat } from "./service";

export const useGetChatContent = (params: ChatParams, options: any) => {
  const queryKeyArr = [
    queryKey.CHAT_LIST,
    ...Object.values(cleanedParams(params)),
  ];
  return useQuery<ChatResponse>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetChatContent(params).then((res: ApiResponse<ChatResponse>) => {
        return res.data.data;
      }),
    ...options,
  });
};

export const useSendMessage = () => {
  return useMutation({
    mutationFn: ({ params }: { params: SendChatParams }) => apiSendChat(params),
  });
};
